export const TOAST_CATEGORY_KEY = 'portal' as const;
export const TOAST_COMPONENT_KEY = 'toast' as const;
